export default __webpack_public_path__ + "static/media/image-home-xl.2fb0b50c.png";